import { render, staticRenderFns } from "./Shareholders-percentage-form.vue?vue&type=template&id=62b3b89c&scoped=true"
import script from "./Shareholders-percentage-form.vue?vue&type=script&lang=js"
export * from "./Shareholders-percentage-form.vue?vue&type=script&lang=js"
import style0 from "./Shareholders-percentage-form.vue?vue&type=style&index=0&id=62b3b89c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b3b89c",
  null
  
)

export default component.exports